import React from 'react'
import MetricCard from '../../../common/components/atom/MetricCard/MetricCard'
import {
  VoltageIcon,
  PowerFactorIcon,
} from '../../../common/components/atom/MetricCard/icons'
import useLuminaireFleetMetrics from '../../../features/luminaire/hooks/useLuminaireFleetMetrics'
import styles from './LuminaireFleetMetrics.module.scss'

export interface LuminaireFleetMetricsProps {
  tags?: string[]
}

export default function LuminaireFleetMetrics({ tags }: LuminaireFleetMetricsProps) {
  const { totalCount, totalActiveEnergyKwh, isLoading } = useLuminaireFleetMetrics({ tags })

  return (
    <div className={styles.fleetMetricsContainer}>
      <div className={styles.metricsGrid}>
        <MetricCard
          title="Nombre de luminaires"
          value={isLoading ? '...' : String(totalCount)}
          unit=""
          icon={<PowerFactorIcon />}
          status="ok"
          showPercentage={false}
          showIcon={false}
        />

        <MetricCard
          title="Énergie active totale"
          value={isLoading ? '...' : totalActiveEnergyKwh.toFixed(2)}
          unit="kWh"
          icon={<VoltageIcon />}
          status="ok"
          showPercentage={false}
          showIcon={false}
        />
      </div>
    </div>
  )
}
